import { Injectable } from "@angular/core";
import { concatMap, forkJoin, map, mergeMap, Observable, of, tap, toArray } from "rxjs";
import { Subject } from "../../../_objects/subject";
import { SubjectDbService } from "../../database/subject-db.service";
import { SubjectService } from "../../http-api/subject.service";
import { toNewSubjectDto } from "../sync-mapper";
import { OnPremiseSyncDataState } from "./on-premise-sync-state.service";
import { SubjectSchema } from "../../../_offline/models/subject.schema";

@Injectable({
  providedIn: "root"
})
export class SubjectOnPremiseSyncService {
  constructor(
    private subjectService: SubjectService,
    private subjectsDbService: SubjectDbService,
    private syncState: OnPremiseSyncDataState
  ) {}

  createSubjects(): Observable<Subject[]> {
    const offlineModelIds = Object.keys(this.syncState.syncDataState.inspectionTemplate);
    if (offlineModelIds.length === 0) {
      return of([]);
    }

    const subjectsObservables = offlineModelIds.map((id) => this.createSubjectsFromModel(id));

    return forkJoin(subjectsObservables).pipe(map((arrayOfSubjectArrays) => arrayOfSubjectArrays.flat()));
  }

  private createSubjectsFromModel(modelId: string): Observable<Subject[]> {
    return this.subjectsDbService.getAllOnPremise(modelId).pipe(
      concatMap((subject) => subject),
      mergeMap((subject) => this.postSubject(subject)),
      toArray()
    );
  }

  private postSubject(subject: SubjectSchema) {
    const subjectNew = toNewSubjectDto(subject, this.syncState.getInspectionTemplateId(subject.subjectModelId));

    return this.subjectService.addSubject(subjectNew).pipe(tap((createdSubject) => this.syncState.updateSubjects(subject.id, createdSubject.id)));
  }
}
